import { useEffect, useState } from 'react'
import { Button, Card, Col, Modal, Row, InputGroup, Container, Form, Table, ButtonGroup } from 'react-bootstrap'
import Cookies from 'js-cookie'
import axios from 'axios'
import config from '../../config'
import useQuery from '../../hooks/useQuery'
import { useHistory, useLocation } from 'react-router'
import { useDispatch } from 'react-redux'

const perPage = 20

const LotteryTemp = () => {
  const query = useQuery()
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const [temps, setTemps] = useState([])
  const [ticker, setTicker] = useState(0)

  const page = Number(query.get('page') || 1)
  const count = Number(query.get('count') || 0)
  const number = query.get('number') || ''

  useEffect(() => {
    ;(async () => {
      if (count === 0 && number === '') {
        return
      }

      dispatch({ type: 'loading_show' })

      try {
        let params = { page, ...(count !== 0 && { count }), ...(number !== '' && { number: number.padStart(6, '.') }) }

        const res = await axios.get(`${config.apiAdminGateway}/api/v2/admin/lotteries/temp`, {
          params,
          headers: { Authorization: `Bearer ${Cookies.get('accessToken')}` },
        })
        const {
          status: { code, description },
          data,
        } = res.data
        if (code !== 0) {
          throw new Error(description)
        }
        setTemps(data)
      } catch (err) {
        alert(err)
        setTemps([])
      }
      dispatch({ type: 'loading_hide' })
    })()
  }, [page, count, number, dispatch, ticker])

  const fetchTemps = async ({ number = '', count = '0' }) => {
    history.replace({ pathname: location.pathname, search: `?number=${number}&count=${count}` })
  }

  const onNext = () => {
    history.replace({
      pathname: location.pathname,
      search: `?page=${page + 1}&number=${number}&count=${count}`,
    })
  }

  const onPrev = () => {
    if (page < 2) {
      return
    }
    history.replace({
      pathname: location.pathname,
      search: `?page=${page - 1}&number=${number}&count=${count}`,
    })
  }

  const onRefresh = () => {
    setTicker((prev) => prev + 1)
  }

  const downloadCountFolder = async () => {
    dispatch({ type: 'loading_show' })
    axios
      .get(`${config.apiAdminGateway}/api/v2/admin/lotteries/folder/download`, {
        responseType: 'blob',
        data: null,
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
          'Content-Type': 'text/csv',
        },
      })
      .then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data)

        // create "a" HTML element with href to file & click
        const link = document.createElement('a')
        link.href = href
        link.setAttribute('download', 'countFolder.csv') //or any other extension
        document.body.appendChild(link)
        link.click()

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link)
        URL.revokeObjectURL(href)
      })
      .finally(() => {
        dispatch({ type: 'loading_hide' })
      })
  }

  const isNextDisabled = temps.length < perPage
  const isPrevDisabled = page < 2

  return (
    <Card>
      <Card.Header>
        <Card.Title>Lottery Temp</Card.Title>
      </Card.Header>
      <Card.Body>
        <Button variant="primary light" onClick={downloadCountFolder}>
          Download count folder
        </Button>
        <ControlPanel searchFn={fetchTemps} />
        <TempTable data={temps} onRefresh={onRefresh} />
      </Card.Body>
      <Card.Footer>
        <ButtonGroup>
          <Button disabled={isPrevDisabled} onClick={onPrev}>{`<`}</Button>
          <Button>{page}</Button>
          <Button disabled={isNextDisabled} onClick={onNext}>{`>`}</Button>
        </ButtonGroup>
      </Card.Footer>
    </Card>
  )
}

const digitLabel = (digit = '') => {
  switch (digit.length) {
    case 2:
      return '2 ตัวท้าย'
    case 3:
      return '3 ตัวท้าย'
    default:
      return '-'
  }
}

const ControlPanel = ({ searchFn }) => {
  const [digitInput, setDigitInput] = useState('')
  const [countInput, setCountInput] = useState('')

  return (
    <Container>
      <Row>
        <Col xs="3">
          <InputGroup className="mb-2">
            <Form.Control
              placeholder="ค้นตัวเลข"
              value={digitInput}
              maxLength={6}
              onChange={(e) => {
                setDigitInput(e.target.value.replace(/[^0-9]/g, ''))
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') {
                  searchFn({ number: digitInput, count: countInput })
                }
              }}
            />
            <InputGroup.Text>{digitLabel(digitInput)}</InputGroup.Text>
          </InputGroup>
        </Col>
        <Col xs="2">
          <Form.Control
            placeholder="ค้นจำนวนชุด"
            value={countInput}
            onChange={(e) => {
              setCountInput(e.target.value.replace(/[^0-9]/g, ''))
            }}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                searchFn({ number: digitInput, count: countInput })
              }
            }}
          />
        </Col>
      </Row>
    </Container>
  )
}

const headers = ['number', 'count', 'roundNo', 'seriesNo', 'location', 'action']

const TempTable = ({ data = [], onRefresh }) => {
  const [cart, setCart] = useState({})

  const onClearCart = () => {
    setCart({})
  }

  const onMakeOrder = () => {
    onClearCart()
    onRefresh()
  }

  return (
    <>
      <Cart data={Object.values(cart)} onClearCart={onClearCart} onMakeOrder={onMakeOrder} />
      <Table striped bordered hover>
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((temp) => (
            <tr key={temp.matrixId}>
              <td>{temp.number}</td>
              <td>{temp.count}</td>
              <td>
                {temp.matrixId.split(',').map((l) => {
                  return <div key={`roundNo-${l}`}>{l.split('-')[1] || '-'}</div>
                })}
              </td>
              <td>
                {temp.matrixId.split(',').map((l) => {
                  return <div key={`seriesNo-${l}`}>{l.split('-')[2] || '-'}</div>
                })}
              </td>
              <td>
                {temp.location.split(',').map((l, i) => {
                  return <div key={l + i}>{l}</div>
                })}
              </td>
              <td>
                <Button
                  onClick={() => {
                    setCart((prev) => {
                      if (prev[temp.id]) {
                        return prev
                      }
                      return { ...prev, [temp.id]: temp }
                    })
                  }}
                >
                  +
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  )
}

const Cart = ({ data = [], onClearCart, onMakeOrder }) => {
  const [open, setOpen] = useState(false)
  const [userId, setUserId] = useState('')
  const [userData, setUserData] = useState(null)
  const [ignore, setIgnore] = useState(false)
  const [confirmWagyuOpen, setConfirmWagyuOpen] = useState(false)

  const dispatch = useDispatch()

  const total = data.reduce((acc, item) => acc + Number(item.count), 0)

  const findByUserId = async (userId = '') => {
    dispatch({ type: 'loading_show' })
    try {
      if (userId.trim() === '') {
        setUserData(null)
        return null
      }
      const res = await axios.get(`${config.apiAdminGateway}/api/v1/admin/users`, {
        params: { userId, page: 1 },
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      })
      const {
        status: { code, description },
        data = [],
      } = res.data
      if (code !== 0) {
        throw new Error(description)
      }
      if (data.length === 0) {
        throw new Error('ไม่พบข้อมูล')
      }
      setUserData(data[0])
      return data[0]
    } catch (err) {
      alert(err)
      setUserData(null)
      return null
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const isNotAllowed = !ignore && (userId.trim() === '' || userData === null)

  const formatTimestamp = (date) => {
    const pad = (n) => String(n).padStart(2, '0')
    const yyyy = date.getFullYear()
    const mm = pad(date.getMonth() + 1)
    const dd = pad(date.getDate())
    const hh = pad(date.getHours())
    const min = pad(date.getMinutes())
    const ss = pad(date.getSeconds())
    return `${yyyy}${mm}${dd}-${hh}${min}${ss}`
  }

  const triggerDownload = (blob, filename) => {
    const objectUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(objectUrl)
  }

  const parseBlobError = async (err) => {
    if (!axios.isAxiosError(err)) return 'เกิดข้อผิดพลาด กรุณาลองใหม่'
    try {
      const text = await err.response?.data?.text()
      const json = JSON.parse(text)
      return json?.message ?? err.message
    } catch {
      return err.message
    }
  }

  const downloadCsv = async (ids) => {
    dispatch({ type: 'loading_show' })
    try {
      const response = await axios.post(
        `${config.apiAdminGateway}/api/v2/admin/lotteries/download/by-ids`,
        { ids },
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )

      triggerDownload(response.data, `lottery_wagyu_${formatTimestamp(new Date())}.csv`)
      alert('Download CSV สำเร็จ')
    } catch (err) {
      alert(await parseBlobError(err))
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const ignoreLotteries = async (ids) => {
    dispatch({ type: 'loading_show' })
    try {
      const response = await axios.post(
        `${config.apiAdminGateway}/api/v2/admin/lotteries/ignore`,
        { ids },
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )

      triggerDownload(response.data, `lottery_wagyu_${formatTimestamp(new Date())}.csv`)
      alert('Download CSV สำเร็จ')
    } catch (err) {
      alert(await parseBlobError(err))
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const handleCheckout = () => {
    if (isNotAllowed) {
      alert('ไม่อนุญาตให้ทำรายการ')
      return
    }
    if (data.length === 0) {
      alert('กรุณาเลือกหวย')
      return
    }
    if (ignore) {
      setConfirmWagyuOpen(true)
    } else {
      if (!window.confirm('ยืนยันการสั่งซื้อ ?')) return
      processCheckout()
    }
  }

  const processCheckout = async () => {
    dispatch({ type: 'loading_show' })
    try {
      const lotteryIds = data.map((item) => item.id)

      if (ignore && !userData) {
        await ignoreLotteries(lotteryIds)
        setOpen(false)
        onMakeOrder()
        return
      }

      const res = await axios.post(
        `${config.apiAdminGateway}/api/v5/admin/orders/with-lottery`,
        { userNo: userData?.userId, lotteryIds, ignore },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )
      const {
        status: { code, description },
      } = res.data
      if (code !== 0) {
        throw new Error(description)
      }
      setUserData(null)
      setOpen(false)
      setUserId('')
      onMakeOrder()
      await downloadCsv(lotteryIds)
    } catch (err) {
      alert(err)
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  return (
    <>
      <Button
        disabled={total === 0}
        onClick={() => {
          setOpen(true)
        }}
      >
        Checkout ({`${total} ใบ`})
      </Button>
      <Modal size="xl" show={open} onHide={() => setOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Checkout</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            {data.map((item) => (
              <Row key={item.id}>
                <Col xs="2">{item.number}</Col>
                <Col xs="4">{item.count > 1 ? `(ชุด ${item.count} ใบ)` : ''}</Col>
                <Col>{item.location}</Col>
              </Row>
            ))}
          </Container>
          <hr />
          <Container>
            <Row>
              <Col>
                <Form.Control
                  placeholder="เข้าบัญชี (ค้นรหัสสมาชิก)"
                  value={userId}
                  onChange={(e) => {
                    setUserId(e.target.value)
                  }}
                  onKeyUp={(e) => {
                    if (e.key === 'Enter') {
                      findByUserId(userId)
                    }
                  }}
                />
              </Col>
            </Row>
            {userData !== null && (
              <Row>
                <Col>{`${userData.firstName} ${userData.lastName} (${userData.nickName})`}</Col>
              </Row>
            )}
            <Row>
              <Col>
                <Form>
                  <Form.Check
                    checked={ignore}
                    onChange={(e) => {
                      setIgnore(e.target.checked)
                    }}
                    label="Wagyu"
                  />
                </Form>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button disabled={data.length === 0} variant="secondary" onClick={onClearCart}>
            Clear Cart
          </Button>

          <Button onClick={handleCheckout}>Checkout</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={confirmWagyuOpen} onHide={() => setConfirmWagyuOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>ยืนยันการนำลอตเตอรี่ออกจากระบบด้วยวากิว (Wagyu)?</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmWagyuOpen(false)}>
            ยกเลิก
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              setConfirmWagyuOpen(false)
              processCheckout()
            }}
          >
            ยืนยัน
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default LotteryTemp
